import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useAppDispatch, useAppSelector } from '../store/store';
import Modal from '../Components/Modal';
import TextField from '../Components/TextField';
import { Question, MultipleChoice, isMultipleChoice } from '../types';
import { MdAddBox } from 'react-icons/md';
import { addQuestion, updateQuestion } from '../store/features/CreateSurveySlice';
import { addSurveyQuestion, updateSurveyQuestion } from '../Firebase/utils';

export default ({ ...props }) => {

    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const dispatch = useAppDispatch();
    const [question, setQuestion] = useState<Question>(props.question || {
        id: uuidv4(),
        questionText: '',
        type: 'Multiple Choice',
        responses: [],
        questionBody: {
            options: []
        } as MultipleChoice
    });
    const [option, setOption] = useState<string>('');
    const [ optionExists, setOptionExists ] = useState<boolean>(false);

    const handleOptionChange = (e: string) => {
        setOptionExists(false);
        setOption(e);
    };

    const handleAddOption = (option: string) => {
        console.log('option', option);
        if (option === '') {
            return;
        }
        if (isMultipleChoice(question.questionBody) && question.questionBody.options.includes(option as any)) {
            setOptionExists(true);
            return;
        }
        if (isMultipleChoice(question.questionBody)) {
            const updatedOptions = [...question.questionBody.options, option];
            setQuestion({
                ...question,
                questionBody: {
                    ...question.questionBody,
                    options: updatedOptions
                }
            });
            setOption('');
        }
    };

    const handleRemoveOption = (optionToRemove: string) => {
        const updatedOptions = (question.questionBody as MultipleChoice).options.filter(opt => opt !== optionToRemove);
        setQuestion({
            ...question,
            questionBody: {
                ...question.questionBody,
                options: updatedOptions
            } as MultipleChoice
        });
    };

    const handleAdd = async () => {
        try{
            await addSurveyQuestion(user, survey, question);
            dispatch(addQuestion({question, response: {questionId: question.id, questionText: question.questionText, questionType:question.type, results: []}}));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleUpdate = async () => {
        try{
            await updateSurveyQuestion(user, survey, question);
            dispatch(updateQuestion(question));
            props.onClose();
        }catch(err){
            alert(err);
        }
    };

    const handleSubmit = () => {
        if(question.questionText === ''){
            alert('Question cannot be empty');
            return;
        }
        if((question.questionBody as MultipleChoice).options.length < 2){
            alert('Please add at least 2 options');
            return;
        }
        if(props.question){
            handleUpdate();
        }else{
            handleAdd();
        }
    };

    return (
        <Modal title='Multiple Choice Form' styles='gap-4' openState={props.openState} onClose={() => { props.onClose(undefined) }}>
            <div className='flex flex-col gap-6 md:gap-10'>
                <TextField placeholder={'Question'} inputValue={question.questionText} setInputValue={(e) => setQuestion({ ...question, questionText: e })} />
                <div className='grid grid-cols-12'>
                    <TextField styles={`col-span-11 ${optionExists && 'border-red-500'}`} placeholder={'Option'} inputValue={option} setInputValue={(e) => handleOptionChange(e)} />
                    <button className='w-full' onClick={() => handleAddOption(option)}><MdAddBox className='text-5xl' /></button>
                </div>
                {optionExists && <p className='-mt-10 text-red-500'>Option Already Exists</p>}
                <div className='flex flex-col gap-5'>
                    {(question.questionBody as MultipleChoice).options.map((option: string, index: number) => {
                        return (
                            <div className='flex gap-5' key={index}>
                                <p className='flex-grow'>{option}</p>
                                <button onClick={() => handleRemoveOption(option)}>Remove</button>
                            </div>
                        );
                    })}
                </div>
            </div>
            <button onClick={() => { handleSubmit() }} className='w-full bg-[#3da8e2] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>{props.question ? 'Update Question' : 'Add Question'}</button>
        </Modal>
    );
};